<header class="export-sidepanel__header">
    <button type="button" class="export-sidepanel__back" (click)="close.emit()" [attr.aria-label]="'exports.sidepanel.back' | translate">
        <svg sh-icon class="sh-icon" name="arrow-left" aria-hidden="true"></svg>
    </button>
    <h2 class="export-sidepanel__title">{{ "exports.sidepanel.title" | translate }}</h2>
</header>

<div class="export-sidepanel__body">
    <section class="export-sidepanel__scopes">
        <p class="export-sidepanel__scope-label">{{ "exports.sidepanel.scope.label" | translate }}</p>
        @if (showSkeleton()) {
            <span class="export-sidepanel__skeleton" aria-hidden="true"></span>
        } @else {
            @for (option of scopeOptions(); track option.value) {
                <label class="export-sidepanel__scope-option">
                    <input
                        type="radio"
                        class="sh-radio"
                        name="export-scope"
                        [checked]="scope() === option.value"
                        [disabled]="option.disabled"
                        (change)="setScope(option.value)"
                    />
                    <span class="export-sidepanel__scope-text" [class.export-sidepanel__muted]="option.disabled">{{
                        option.labelKey | translate: { count: option.count }
                    }}</span>
                </label>
            }
            @if (formattedSize(); as size) {
                <p class="export-sidepanel__size">
                    &plusmn; {{ size }}
                    <span class="export-sidepanel__muted">({{ "exports.sidepanel.size-estimate-label" | translate }})</span>
                </p>
            }
        }
        <p class="export-sidepanel__scope-note">{{ "exports.sidepanel.scope.note" | translate }}</p>
        @if (isEmpty()) {
            <p class="export-sidepanel__empty">{{ "exports.sidepanel.empty" | translate }}</p>
        }
        @if (exceedsMax()) {
            <div class="export-sidepanel__banner export-sidepanel__banner--danger">
                <svg sh-icon class="sh-icon export-sidepanel__banner-icon" name="warning" aria-hidden="true"></svg>
                <div class="export-sidepanel__banner-content">
                    <p class="export-sidepanel__banner-title">{{ "exports.sidepanel.max-exceeded-title" | translate }}</p>
                    <p class="export-sidepanel__banner-text">
                        {{ "exports.sidepanel.max-exceeded" | translate: { max: maxExportCount } }}
                    </p>
                </div>
            </div>
        }
        @if (showsFailure()) {
            <div class="export-sidepanel__banner export-sidepanel__banner--danger" role="alert">
                <svg sh-icon class="sh-icon export-sidepanel__banner-icon" name="warning" aria-hidden="true"></svg>
                <div class="export-sidepanel__banner-content">
                    <p class="export-sidepanel__banner-title">{{ failure()!.titleKey | translate }}</p>
                    <p class="export-sidepanel__banner-text">{{ failure()!.textKey | translate: failure()!.params }}</p>
                </div>
            </div>
        }
    </section>

    @if (hasValidSelection()) {
        <section class="export-sidepanel__modes">
            <p class="export-sidepanel__format-label">{{ "exports.sidepanel.format-label" | translate }}</p>
            @for (option of modeOptions; track option.value) {
                <label class="export-sidepanel__mode" [class.export-sidepanel__mode--selected]="mode() === option.value">
                    <input type="radio" class="sh-radio" name="export-content-mode" [checked]="mode() === option.value" (change)="setMode(option.value)" />
                    <span class="export-sidepanel__mode-text">
                        <span class="export-sidepanel__mode-title">{{ option.labelKey | translate }}</span>
                        <span class="export-sidepanel__mode-format">{{ option.format }}</span>
                    </span>
                </label>
            }
        </section>

        <div class="export-sidepanel__banner">
            <svg sh-icon class="sh-icon export-sidepanel__banner-icon" name="info" aria-hidden="true"></svg>
            <div class="export-sidepanel__banner-content">
                <p class="export-sidepanel__banner-title">{{ "exports.sidepanel.fouten-note-title" | translate }}</p>
                <p class="export-sidepanel__banner-text">{{ "exports.sidepanel.fouten-note" | translate }}</p>
            </div>
        </div>
    }

    <button type="button" class="sh-button -sh-full-width export-sidepanel__start" [disabled]="!canStart()" (click)="onStart()">
        @if (submitting()) {
            <span class="export-sidepanel__spinner" aria-hidden="true"></span>
        }
        {{ "exports.sidepanel.start" | translate }}
    </button>
</div>
